import type { Component } from 'vue';
import {
  FormHeaderBlock,
  FixedTextElement,
  TextInputElement,
  ParagraphElement,
  NumberInputElement,
  DateInputElement,
  EmailInputElement,
  DropdownElement,
  TableElement,
  RadioGroupElement,
  CheckboxElement,
  UrlInputElement,
  RegisterNumberInputElement,
  IndexerTitleElement,
  FillTitleElement,
} from '../ui/elements';

export const ELEMENT_COMPONENT_MAP: Record<string, Component> = {
  HEADER: FormHeaderBlock,
  FIXED_TEXT: FixedTextElement,
  TEXT_INPUT: TextInputElement,
  PARAGRAPH: ParagraphElement,
  NUMBER_INPUT: NumberInputElement,
  DATE_INPUT: DateInputElement,
  EMAIL_INPUT: EmailInputElement,
  DROPDOWN: DropdownElement,
  TABLE: TableElement,
  RADIO_GROUP: RadioGroupElement,
  CHECKBOX: CheckboxElement,
  URL_INPUT: UrlInputElement,
  REGISTER_NUMBER_INPUT: RegisterNumberInputElement,
  INDEXER_TITLE: IndexerTitleElement,
  FILL_TITLE: FillTitleElement,
} as const;

export function getElementComponent(type: string): Component | null {
  return ELEMENT_COMPONENT_MAP[type] ?? null;
}
